import React, {useEffect, useState} from "react";

interface ContentImage {
  headline: string;
  text: string;
  el:string;
  image: {
    url: string;
    altText: string;
  };
}

const ImageText = (props: ContentImage) => {
  const { headline, text, image, el } = props;
  const [styleDividing, setStyleDividing] = useState('');

  useEffect(() => {
    if ((headline === undefined && text !== undefined && text.length > 0) ||
      (text === undefined && headline !== undefined)) {
      setStyleDividing('text');
    } else if (headline !== undefined && text !== undefined) {
      setStyleDividing('headline');
    } else {
      setStyleDividing(' ');
    }
  });

  return (
    <>
      <div className={`image-text ${el}`}>
        <div className="image-text__image">
          <img className="av-topic-line__image" src={image.url} alt={image.altText}/>
        </div>
        {(headline || text) &&
          <div  className="image-text__content">
              { headline &&
                <div  className="image-text__headline">
                  <p className={`hl-4 ${styleDividing}`} >
                    <strong dangerouslySetInnerHTML={{__html: headline || ''}}/>
                  </p>
                </div>
              }
              { text &&
                <div  className="image-text__text tx-1" dangerouslySetInnerHTML={{ __html: text || '' }} />
              }
          </div>}
      </div>
    </>
  )
};

export default ImageText;
